import { useState } from "react";
import { Button, Col, Row, Table } from "react-bootstrap";
import AddOrNoMask from "./AddOrNoMask";
import AddressMask from "../../anlage/new/AddressMask.jsx";
import AnlageDataMask from "../../anlage/new/AnlageDataMask";
import Validator from "../../../../services/Validator";
import RegisterMask from "../../anlage/new/RegisterMask";
import SummaryMask from "../../anlage/new/SummaryMask";
import CommonUtils from "../../../../utils/common";
import { FaXmark } from "react-icons/fa6";

const AnlagenMask = ({data, setData, setPlaces, setMainStep}) => {

    // ! -------------
    // ! Global vars |
    // ! -------------
    const VALIDATOR = new Validator();
    const UTILS = new CommonUtils();

    const defaultAnlageData = {
        contact: data.contact,
        country_id: data.country_id,
        state_id: data.state_id,
        zip: data.zip,
        city: data.city,
        street: data.street,
        houseNr: data.houseNr,

        x_anlagenverwendung: "",
        x_anlagenverwendung_detail: "",
        bestand: "",
        stiege: "",
        top: "",
        leerstand: false,

        energyForm: "",
        x_is_smartmeter_01: false,
        x_is_smartmeter_02: false,
        secondZaehler: false,
        zaehlerLocation: "",
        x_zaehlernummer_01: "",
        x_zaehlernummer_02: "",
        x_zaehlpunktnummer_01: "",
        x_zaehlpunktnummer_02: "",
        x_zaehlerstand_01: "",
        x_zaehlerstand_02: "",

        register: true,
        registerDate: "",
        useMtu: false,
        mtuName: "",
        mtuDirect: false,
        mtuPaysOverTransfer: false,
        mtuAccountOwner: "",
        mtuIban: ""
    };
    const [anlageData, setAnlageData] = useState(defaultAnlageData);
    const [anlagenFormError, setAnlagenFormError] = useState({});
    const [step, setStep] = useState("addOrNo");
    const stepIndicator = [
        {id: "step1", key: "addOrNo"},
        {id: "step2", key: "address"},
        {id: "step3", key: "anlageData"},
        {id: "step4", key: "register"},
        {id: "step5", key: "summary"},
    ];


    // ! -----------
    // ! Functions |
    // ! -----------
    // * Back button handler
    const backBtnHandler = () => {
        if (step === "addOrNo") {
            return setMainStep("abrechnung")
        }

        const index = stepIndicator.findIndex(i => i.key === step);
        if (index > 0) {
            setStep(stepIndicator[index - 1].key);
        }
    }

    // * Next button handler
    const nextBtnHandler = () => {
        // checks
        var tmpError = {};
        if (step === "address") {
            if (anlageData.x_anlagenverwendung === "") tmpError.x_anlagenverwendung = true;
            if (anlageData.x_anlagenverwendung === "Wohnung" && anlageData.top === "") tmpError.top = true;
            if (anlageData.x_anlagenverwendung === "Allgemeine Liegenschaftsteile" && anlageData.x_anlagenverwendung_detail === "") tmpError.x_anlagenverwendung_detail = true;
            
            // fix Leerstand when Allgemeine
            if (data.x_anlagenverwendung === "Allgemeine Liegenschaftsteile") setAnlageData(prev => ({...prev, leerstand: false}));
        }
        if (step === "anlageData") {
            if (!VALIDATOR.isValidEnergyForm(anlageData.energyForm)) tmpError.energyForm = true;
            if (anlageData.x_zaehlernummer_01.length < 6) tmpError.x_zaehlernummer_01 = true;
            if (anlageData.secondZaehler === true && anlageData.x_zaehlernummer_02.length < 6) tmpError.x_zaehlernummer_02 = true;
            if (
                anlageData.x_zaehlpunktnummer_01 !== "" &&
                !VALIDATOR.isFormatedZaehlpunknummerValid(anlageData.x_zaehlpunktnummer_01)
            ) tmpError.x_zaehlpunktnummer_01 = true;
            if (
                anlageData.x_zaehlpunktnummer_02 !== "" &&
                !VALIDATOR.isFormatedZaehlpunknummerValid(anlageData.x_zaehlpunktnummer_02)
            ) tmpError.x_zaehlpunktnummer_02 = true;
        }
        if (step === "register") {
            if (anlageData.register === true) {
                if (!VALIDATOR.dateValid(anlageData.registerDate)) tmpError.registerDate = true;
                if (anlageData.x_is_smartmeter_01 === false) {
                    if (!VALIDATOR.IsZaehlerstand(anlageData.x_zaehlerstand_01)) tmpError.x_zaehlerstand_01 = true;
                    if (anlageData.secondZaehler === true && !VALIDATOR.IsZaehlerstand(anlageData.x_zaehlerstand_02)) tmpError.x_zaehlerstand_02 = true;
                }
                if (anlageData.useMtu === true) {
                    if (anlageData.mtuName.length < 4) tmpError.mtuName = true;
                    if (anlageData.mtuDirect === true) {
                        if (anlageData.mtuAccountOwner.length < 4) tmpError.mtuAccountOwner = true;
                        if (!VALIDATOR.formatedIbanValid(anlageData.mtuIban)) tmpError.mtuIban = true;
                    }
                }
            }
        }

        // next on addOrNo step will change main step
        if (step === "addOrNo") {
            return setMainStep("summary");
        }


        // next on summary adds anlage to anlage list
        if (step === "summary") {
            var tmpAnlage = {...anlageData};
            setData(prev => ({
                ...prev, 
                anlagen: [tmpAnlage, ...prev.anlagen]
            }));
            setAnlageData(defaultAnlageData);
            return setStep("addOrNo");
        }

        // if there where errors return it 
        if (Object.keys(tmpError).length > 0) {
            return setAnlagenFormError(tmpError);
        }

        // go to next step
        const index = stepIndicator.findIndex(i => i.key === step);
        setStep(stepIndicator[index + 1].key);
    }

    const removeAnlageFromList = (indexToRemove, e) => {
        e.preventDefault();
        setData(prev => ({
            ...prev, // zadrži ostala polja (field1, field2, field3)
            anlagen: prev.anlagen.filter((_, index) => index !== indexToRemove)
        }));
    }

    return (
        <>
            {data.anlagen.length > 0 && step === "addOrNo" &&
                <Row className="mb-3">
                    <Col>
                        <p className="text-muted">Erfasste Anlagen</p>
                        <Table hover responsive="sm">
                            <thead>
                                <tr>
                                    <td>#</td>
                                    <td>Anlagenverwendung</td>
                                    <td>Top</td>
                                    <td>Spez. Anlagenverwendung</td>
                                    <td>Energieform</td>
                                    <td className="text-center">Anlage anmelden</td>
                                    <td className="text-center">Löschen</td>
                                </tr>
                            </thead>
                            <tbody>
                                {data.anlagen.map((anlage, i) => (
                                    <tr key={`anlage-${i}`}>
                                        <td>{i + 1}</td>
                                        <td>{anlage.x_anlagenverwendung}</td>
                                        <td>{anlage.top}</td>
                                        <td>{anlage.x_anlagenverwendung_detail}</td>
                                        <td>{anlage.energyForm}</td>
                                        <td className="text-center">{UTILS.checkUncheckIcons(anlage.register)}</td>
                                        <td className="text-center">
                                            <a 
                                                href="/löschen" 
                                                className="link-energo text-danger"
                                                onClick={e => removeAnlageFromList(i, e)}
                                            >
                                                <FaXmark />
                                            </a>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </Table>
                    </Col>
                </Row>
            }
            <Row>
                <Col>
                    {
                        step === "addOrNo" ?
                            <AddOrNoMask setStep={setStep} data={data} /> :
                        step === "address" ? 
                            <AddressMask data={anlageData} setData={setAnlageData} formError={anlagenFormError} setFormError={setAnlagenFormError} setPlaces={setPlaces} hwMode addressFilled /> :
                        step === "anlageData" ?
                            <AnlageDataMask data={anlageData} setData={setAnlageData} formError={anlagenFormError} setFormError={setAnlagenFormError} /> :
                        step === "register" ?
                            <RegisterMask data={anlageData} setData={setAnlageData} formError={anlagenFormError} setFormError={setAnlagenFormError} hwMode /> :
                        step === "summary" ?
                            <SummaryMask data={anlageData} setStep={setStep} hwMode /> :
                            null
                    }
                </Col>
            </Row>
            <Row className="mt-3">
                <Col className="text-end">
                    <Button onClick={backBtnHandler} className="btn-warning me-2">Zurück</Button>
                    <Button onClick={nextBtnHandler} variant="energo" >
                        {
                            step === "summary"?
                                "Anlage hinzufügen" :
                            step === "addOrNo"?
                                data.anlagen.length > 0 ?
                                    "Anlagen hinzufügen abschließen" :
                                    "Keine Anlagen hinzufügen" :
                                "Weiter"
                        }
                    </Button>
                </Col>
            </Row>
        </>
    )

}
export default AnlagenMask;